/** dd/mm/aaaa hh:mm (pt-BR) */
export function formatDateTime(value: string | Date): string {
  const d = typeof value === 'string' ? new Date(value) : value;
  const date = d.toLocaleDateString('pt-BR');
  const time = d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  return `${date} ${time}`;
}

/** Tamanho de arquivo legível (B / KB / MB). */
export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1).replace('.', ',')} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1).replace('.', ',')} MB`;
}

/** Inicial para o avatar do autor ('?' quando sem nome). */
export function initialOf(name: string | null | undefined): string {
  return (name?.trim().charAt(0) ?? '?').toUpperCase() || '?';
}

/** 'N conhecimentos nesta pasta' (singular quando N = 1). */
export function knowledgeCountLabel(count: number): string {
  return count === 1 ? '1 conhecimento nesta pasta' : `${count} conhecimentos nesta pasta`;
}
